<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="faq_search-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path id="Path_1607" data-name="Path 1607" d="M0,0H24V24H0Z" fill="none" />
    <path
      id="Path_1608"
      data-name="Path 1608"
      d="M15.714,6.838a6.276,6.276,0,1,1-8.876,0,6.276,6.276,0,0,1,8.876,0"
      fill="none"
      :stroke="clr ? clr : '#002'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_1609"
      data-name="Path 1609"
      d="M19,19l-3.29-3.29"
      fill="none"
      :stroke="clr ? clr : '#002'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
